<big-ui-modal-frame
    *transloco="let t; prefix: 'uiModalFormClose'"
    [closeBtnTitle]="t('closeOverlayBtn')"
    (closeModal)="popoverRef.close({ leaveForm: false })">
    <ng-container title>{{ t('title') }}</ng-container>
    <ng-container content>{{ t('content') }}</ng-container>
    <ng-container buttonBar>
        <div class="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
            <big-ui-button
                [buttonStyle]="'secondary'"
                [id]="'leave-form-btn'"
                (clicked)="popoverRef.close({ leaveForm: true })"
                [title]="t('leaveBtn')">
                <big-icon
                    [icon]="iconClose"
                    [size]="'w-3.5'"
                    class="fill-current"></big-icon>
                <span>{{ t('leaveBtn') }}</span>
            </big-ui-button>
            <big-ui-button
                [buttonStyle]="'primary'"
                [id]="'close-overlay-btn'"
                (clicked)="popoverRef.close({ leaveForm: false })"
                [title]="t('closeOverlayBtn')">
                <span>{{ t('closeOverlayBtn') }}</span>
            </big-ui-button>
        </div>
    </ng-container>
</big-ui-modal-frame>
